import React from "react"
import PropTypes from "prop-types"

import LexSchedule from './LexSchedule';
import StandardButton from '../app_components/StandardButton'
import TopicsContainer from '../exchanges_sections/TopicsContainer'
import MeetingTopics from './MeetingTopics'

class ScheduleLexTopics extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      buttonText: "Submit",
      lang_one: '',
      lang_two: '',
      currentUserLanguage: '',
      selected: '',
      chooseActivities: false,
      meeting: ''
    }

    this.changeSelect = this.changeSelect.bind(this)
    this.toggleActivities = this.toggleActivities.bind(this)
    this.renderMeetingTopics = this.renderMeetingTopics.bind(this)
    this.setSettings = this.setSettings.bind(this)
  }

  setSettings() {
    if(this.state.languages.includes(this.state.meeting.lang_one_id)) {
      this.setState({ currentUserLanguage: 1, selected: 1 })
    } else {
      this.setState({ currentUserLanguage: 2, selected: 2 })
    }
    if(this.state.meeting.requestor_id === this.state.current_user.id) {
      this.setState({
        otherUser: this.state.meeting.requestee,
        currentUser: this.state.meeting.requestor
      })
    } else {
      this.setState({
        otherUser: this.state.meeting.requestor,
        currentUser: this.state.meeting.requestee
      })
    }
  }


  componentDidMount() {
    $.ajax({
      url: `../schedule_lex_topics`,
      dataType: 'JSON',
      type: 'POST',
      data: {
        meeting_id: this.props.meetingId
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          languages: data.data.languages,
          current_user: data.data.current_user,
          topics: data.data.topics,
          meeting: data.data.meeting,
          lang_one: data.data.lang_one,
          lang_two: data.data.lang_two
        }, () => this.setSettings())
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });

  }

  componentWillUnmount() {
    this.setState({
      chooseActivities: false
    })
  }

  changeSelect(n) {
    this.setState({
      selected: n
    })
  }

  toggleActivities() {
    this.setState({
      chooseActivities: !this.state.chooseActivities
    })
  }

  renderMeetingTopics() {
    if(this.state.selected === 1) {
      return(<MeetingTopics isCurrentUser={this.state.currentUserLanguage === this.state.selected} meetingId={this.state.meeting.id} userId={(this.state.currentUserLanguage === 1) ? this.state.currentUser.id : this.state.otherUser.id}/>)
    } else if(this.state.selected === 2) {
      return(<MeetingTopics isCurrentUser={this.state.currentUserLanguage === this.state.selected} meetingId={this.state.meeting.id} userId={(this.state.currentUserLanguage === 2) ? this.state.currentUser.id : this.state.otherUser.id}/>)
    }
    return null
  }

  render() {
    if(this.state.chooseActivities === true) {
      return(
        <div style={{padding: 12, textAlign: 'center'}}>
          <div style={{
            borderRadius: 30,
            backgroundColor: '#03A9F4',
            alignSelf: 'flex-start',
            width: 170,
            padding: 12,
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            cursor: 'pointer'
          }} onClick={() => this.toggleActivities()}>
            <img src={this.props.backIcon} style={{transform: 'rotate(90deg)', width: 20, display: 'inline-block'}} />
            <h5 style={{textAlign: 'center', color: '#fff', display: 'inline-block', fontWeight: 600}}>Back to Meeting</h5>
          </div>
          <TopicsContainer searchLottie={this.props.searchLottie} favoriteStarLottie={this.props.favoriteStarLottie} meetingId={this.state.meeting.id}/>
        </div>
      )
    }
    if(this.state.meeting != '') {
    return(
      <div style={{padding: 12, textAlign: 'center'}}>
        <h3 className="darkBlue">Lex Schedule</h3>
        <LexSchedule
          meeting={this.state.meeting}
          lang_one={this.state.lang_one}
          lang_two={this.state.lang_two}
          selected={this.state.selected}
          changeSelect={this.changeSelect}
          otherUser={this.state.otherUser}
          currentUser={this.state.currentUser}
          currentUserLanguage={this.state.currentUserLanguage}
        />
        {this.renderMeetingTopics()}
        {(this.state.selected === this.state.currentUserLanguage) &&
          <div style={{maxWidth: 350, margin: 'auto'}}>
            <StandardButton
              size={'large'}
              primary={true}
              onClick={this.toggleActivities}
              text="Add activities"/>
          </div>
          }
      </div>
    )
    }
    return null
  }

}

export default ScheduleLexTopics;
